export enum TabListLabelPending {
  register = 'Pengajuan Pendaftaran',
  submission = 'Pengajuan Pembaruan Data',
}

export enum TabListLabelTerverifikasi {
  active = 'Aktif',
  nonactive = 'Nonaktif',
}
